const initialState = () => ({
  newRoutine: {
    id: null,
    name: null,
    roleId: null,
    users: [],
    periodicity: 'daily',
    duration: '1',
    startDate: null,
    endDate: null
  },
  newEvent: {
    type: null,
    name: null,
    formId: null,
    programmingType: 'goals',
    monthlyType: 'the',
    description: null,
    frequency: 'daily',
    goal: '1',
    days: [],
    day: { label: 'Lu', complete: 'lunes', value: 'monday' },
    ordinal: 'first',
    startHour: null,
    endHour: null,
    allDay: false,
    enforceDeadline: false,
    locations: [],
    requiredPhoto: false,
    category: null,
    category2: null,
    priority: null,
    taskByLocations: false,
    comment: null,
    pictures: [],
    file: null,
    link: null,
    showDayConfig: false,
    showMultipleVisits: false,
    data: {}
  },
  routines: [],
  events: [],
  // TKT-2245 F4 — capacidades de edicion que el backend autoriza para este usuario.
  // Vacio = congelado (Fase 0), que es el default mientras no llegue la respuesta.
  routineCapabilities: {},
  eventsFilters: {
    type: ['event', 'form', 'task'],
    programming: ['daysHours', 'goals'],
    order: 'byCreation'
  },
  // TKT-2245 Fase 2 — conteo de impacto (previewUpdate) para el paso de confirmacion
  // antes de guardar un cambio global. null = aun no se pidio o no aplica.
  updatePreview: null,
  updatePreviewLoading: false,
  loading: false,
  eventLoading: false
})

export default initialState
